/* src/app/shared/components/timeline/timeline.component.css */
.ant-timeline li.list-padding:not(:first-child) {
  padding-top: 5px !important;
}
/*# sourceMappingURL=timeline.component-WFGEQIYJ.css.map */
